// Brand/theme tokens used across screens
export const THEME = {
  colors: {
    brand: '#FCD000',
    bg: '#000000',
    surface: '#111111',
    surface2: '#141414',
    chip: '#1a1a1a',
    text: '#FFFFFF',
    textMuted: '#AAAAAA',
    border: '#222222',
    borderStrong: '#333333',
  },
  radius: { sm: 8, md: 10, lg: 12, pill: 16 },
  space:  { xs: 6, sm: 8, md: 12, lg: 16, xl: 20 },
  font:   { weightBold: '800', weightHeavy: '900' },
};
